import type { LinearFn2d, Point2d } from "../2d"

export const makeTinyOffsets = (
  p: Point2d,
  fn: LinearFn2d,
): [Point2d, Point2d] => {
  const rise = fn.slope === Infinity ? 1 : fn.slope
  const run = fn.slope === Infinity ? 0 : 1
  const total = Math.abs(rise) + run
  const xFactor = isFinite(run) ? run / total : 1
  const yFactor = isFinite(rise) ? rise / total : 1
  const offsetPointA = { x: p.x + 0.01 * xFactor, y: p.y + 0.01 * yFactor }
  const offsetPointB = { x: p.x - 0.01 * xFactor, y: p.y - 0.01 * yFactor }

  return [offsetPointA, offsetPointB]
}
